import { useTranslation } from "react-i18next";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { useQuery } from "@tanstack/react-query";
import i18n from "../../../i18n";
import { getFiltersSurveyImportDetails } from "../api/getFiltersSurveyImportDetails";

type QueryFnType = typeof getFiltersSurveyImportDetails;
type UseFiltersOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useFilterSurveyImportDetails = (config?: UseFiltersOptions) => {
    const { t } = useTranslation(["survey"]);
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ["filtersDetailSurveyLoads", i18n.language],
        queryFn: async () => {
            const filters = await getFiltersSurveyImportDetails(t);

            // translate here
            return filters;
        }
    });
};